import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers/RootReducer";
import logger from "redux-logger";
import thunk from "redux-thunk";
const composeEnhancers = compose; // add support for Redux dev tools
export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk, logger))
);
